/** Presentation only: preserve the exact control message and every backend guard. */
export function ChatFehlerHinweis({ text }: { text: string }) {
  const zug = /^(?:Codex: )?Bühnenzug (gesperrt|angehalten):/.exec(text);
  if (!zug) return <>{text}</>;
  const aufgaben = zug[1] === 'gesperrt' && /Eingaben sind noch nicht mit dem gemeinsamen Aufgabenpool abgeglichen/.test(text);
  return <div data-ai-id="cui-zugschutz-hinweis">
    <div role="status">{aufgaben ? 'Aufgabenabgleich noch offen.' : 'Der Arbeitsabschluss ist noch nicht bestätigt.'}
      {' '}{zug[1] === 'gesperrt' ? 'Die automatische Nacharbeit ist angehalten.' : 'Der Arbeitszug ist angehalten.'}</div>
    <p style={{ margin: '4px 0', fontWeight: 400 }}>
      {aufgaben ? 'Die zuständige Sitzung muss ihre Eingänge und offenen Übernahmen abgleichen. ' : ''}
      „Aktualisieren“ liest den aktuellen Stand; es startet keine neue Arbeit.
    </p>
    <details>
      <summary style={{ cursor: 'pointer', fontWeight: 400 }}>Technische Einzelheiten</summary>
      <pre style={{ maxHeight: '24vh', overflow: 'auto', whiteSpace: 'pre-wrap', overflowWrap: 'anywhere',
        fontSize: 11, fontWeight: 400, margin: '6px 0 0', fontFamily: 'inherit' }}>{text}</pre>
    </details>
  </div>;
}
